//#region src/v2/features/localization/locales/zh-tw.ts
/** Built-in API Client translations for zh-TW. */
var zhTw = {
	"serverVariablesSelect": { "selected": "已選擇：" },
	"serverVariablesTextbox": { "value": "值" },
	"sidebarListElementForm": { "cancel": "取消" },
	"requestBlock": {
		"authentication": "身分驗證",
		"variables": "變數",
		"cookies": "Cookie",
		"headers": "請求標頭",
		"queryParameters": "查詢參數",
		"queryString": "查詢字串",
		"queryStringDescription": "此參數提供完整的查詢字串，因此無法新增其他命名參數。現有命名參數將在其後傳送；重複的鍵會被保留。",
		"requestBody": "請求主體",
		"requestName": "請求名稱",
		"label": "請求：{name}"
	},
	"responseBlock": {
		"requestFailed": "請求失敗",
		"networkErrorHelp": "可能的原因包括 CORS 限制或網路連線問題。請查看瀏覽器主控台以瞭解詳細資訊。如果 CORS 阻止了請求，請設定 API 伺服器以允許此來源，或使用可信任的代理伺服器。",
		"response": "回應",
		"requestHeaders": "請求標頭",
		"responseHeaders": "回應標頭",
		"body": "主體"
	},
	"codeInput": {
		"required": "必填",
		"exitHint": "按 {escape}，然後按 {tab} 離開"
	},
	"codeInputLite": { "required": "必填" },
	"dataTableInput": {
		"clearValue": "清除值",
		"resetValue": "恢復預設值",
		"showPassword": "顯示密碼",
		"hidePassword": "隱藏密碼"
	},
	"dataTableInputSelect": {
		"value": "值",
		"addValue": "新增值"
	},
	"confirmationForm": {
		"cancel": "取消",
		"save": "儲存"
	},
	"collapsibleSection": {
		"collapsed": "（已摺疊）",
		"item": "項",
		"items": "項"
	},
	"modalClientContainer": { "label": "API 用戶端" },
	"serverDropdown": {
		"server": "伺服器：",
		"addServer": "新增伺服器",
		"updateServers": "更新伺服器",
		"unknownServer": "未知伺服器"
	},
	"sidebar": { "search": "搜尋" },
	"sidebarMenu": { "settings": "設定" },
	"sidebarToggle": {
		"hide": "隱藏側邊欄",
		"show": "顯示側邊欄"
	},
	"environmentsList": { "addEnvironment": "新增環境" },
	"modal": { "noDocumentSelected": "未選擇文件" },
	"operation": { "selectAnOperationToViewDetails": "選擇一個操作以檢視詳細資訊" },
	"header": {
		"operationSettings": "操作設定",
		"closeClient": "關閉用戶端"
	},
	"openApiClientButton": { "openAPIClient": "開啟 API 用戶端" },
	"requestBody": {
		"noBody": "無請求主體",
		"delete": "刪除",
		"selectFile": "選擇檔案",
		"multipartForm": "多部分表單",
		"formUrlEncoded": "URL 編碼表單",
		"binaryFile": "二進位檔案",
		"other": "其他",
		"none": "無"
	},
	"requestBodyStructured": { "body": "主體" },
	"requestBodyViewToggle": {
		"schema": "結構描述",
		"form": "表單",
		"raw": "原始內容",
		"fixBody": "修正請求主體以切換到表單檢視"
	},
	"requestCodeSnippet": {
		unavailable: "此範例沒有可用的程式碼範例。",
		"codeSnippet": "程式碼片段"
	},
	"requestTable": {
		"enabled": "已啟用",
		"key": "鍵",
		"value": "值"
	},
	"requestTableRow": {
		"key": "鍵",
		"value": "值",
		"delete": "刪除",
		"selectFile": "選擇檔案",
		"globalCookieHint": "全域 Cookie 在整個工作區中共用。點擊前往檢視。",
		"readOnlyHint": "此屬性為唯讀。若要更改，請覆蓋該屬性或透過核取方塊停用它。",
		"include": "在請求中包含 {name}",
		"keyLabel": "{name} 的鍵",
		"valueLabel": "{name} 的值",
		"deleteRow": "刪除 {name}",
		"row": "列"
	},
	"requestTableTooltip": {
		"min": "最小值：",
		"max": "最大值：",
		"default": "預設值：",
		"invalid": "輸入無效",
		"moreInformation": "更多資訊"
	},
	"headers": {
		"headerKey": "標頭鍵",
		"headerValue": "標頭值",
		"noHeaders": "無標頭"
	},
	"responseBody": { "binaryFile": "二進位檔案" },
	"responseBodyPreview": { "previewUnavailable": "無法預覽" },
	"responseBodyStreaming": {
		"body": "主體",
		"listening": "正在監聽…",
		"cancel": "取消"
	},
	"responseBodyToggle": {
		"preview": "預覽",
		"raw": "原始內容"
	},
	"responseBodyVirtual": {
		"body": "主體",
		"largeBodyHint": "此回應主體過大，無法進行語法醒目提示。"
	},
	"responseCookies": {
		"cookies": "Cookie",
		"cookieName": "Cookie 名稱",
		"cookieValue": "Cookie 值",
		"noCookies": "無 Cookie"
	},
	"responseEmpty": {
		"roadmap": "路線圖",
		"poweredByScalarcom": "由 Scalar.com 提供支援",
		"getStarted": "開始使用",
		"newRequest": "新增請求",
		"sendRequest": "傳送請求",
		"version": "Scalar App V{version} 測試版"
	},
	"responseLoadingOverlay": { "cancel": "取消" },
	"addressBar": {
		"path": "路徑",
		"copyUrl": "複製 URL",
		"send": "傳送",
		"sendRequest": "向 {url} 傳送 {method} 請求",
		"duplicateRequest": "此文件中已存在發往 {path} 的 {method} 請求",
		"urlPlaceholder": "輸入 URL",
		"webhookUrlPlaceholder": "輸入完整的 Webhook URL，例如 https://example.com/hook"
	},
	"addressBarHistory": { "requestHistory": "請求歷史" },
	"environmentSelector": {
		"noEnvironment": "無環境",
		"notAvailableInThisContext": "在此情境中不可用",
		"environmentHint": "環境可幫助您管理不同情境中的變數，例如 API 金鑰和基底 URL。",
		"add": "新增環境",
		"select": "選擇環境",
		"unavailable": "{name}（不可用）",
		"current": "目前環境：{name}"
	},
	"deleteRequestAuthModal": {
		"deleteSecurityScheme": "刪除安全方案",
		"cancel": "取消",
		"delete": "刪除",
		"confirmation": "此操作無法復原。您即將從集合中刪除安全方案 {name}。"
	},
	"oauth2": {
		deviceAuthorizationUrl: "裝置授權 URL",
		deviceVerificationPrompt: "開啟驗證頁面並輸入此驗證碼：",
		waitingForAuthorization: "正在等待授權…",
		cancelDeviceAuthorization: "取消",
		"accessToken": "存取權杖",
		"refreshUrl": "更新 URL",
		"refresh": "更新",
		"authUrl": "身分驗證 URL",
		"tokenUrl": "權杖 URL",
		"redirectUrl": "重新導向 URL",
		"username": "使用者名稱",
		"password": "密碼",
		"clientID": "用戶端 ID",
		"clientSecret": "用戶端金鑰",
		"usePKCE": "使用 PKCE",
		"credentialsLocation": "認證資訊位置",
		"authorize": "授權",
		"clear": "清除",
		"failedToauthorize": "授權失敗",
		"failedToRefreshToken": "更新權杖失敗",
		"optionalRedirectUrl": "選填的重新導向 URL",
		"clearTokens": "清除權杖",
		"resetDiscovery": "重設探索"
	},
	"oauthScopesAddModal": {
		"name": "名稱：",
		"description": "描述：",
		"readUserData": "讀取使用者資料",
		"edit": "編輯權限範圍",
		"add": "新增權限範圍",
		"save": "儲存",
		"required": "權限範圍名稱為必填項。",
		"duplicate": "名為「{name}」的權限範圍已存在。"
	},
	"oauthScopesInput": {
		"noScopesDefined": "尚未定義權限範圍",
		"addScope": "新增權限範圍",
		"deselectAll": "取消全選",
		"selectAll": "全選",
		"selectedScopes": "已選權限範圍：{count} / {total}",
		"editScope": "編輯 {name}",
		"deleteScope": "刪除 {name}",
		"selectScope": "選擇權限範圍 {name}"
	},
	"openIdConnect": {
		"discoveryUrl": "探索 URL",
		"fetchConfiguration": "取得設定",
		"failedToFetchConfiguration": "取得 OpenID Connect 設定失敗"
	},
	"requestAuthDataTable": { "noauthenticationSelected": "未選擇身分驗證" },
	"requestAuthTab": {
		"token": "權杖",
		"bearerToken": "Bearer 權杖",
		"getAToken": "取得權杖",
		"refresh": "更新",
		"username": "使用者名稱",
		"password": "密碼",
		"name": "名稱",
		"value": "值",
		"cancel": "取消",
		"authorize": "授權",
		"unsupportedCredentials": "瀏覽器用戶端不會傳送此 AsyncAPI 安全方案的認證資訊。",
		"authorizeVia": "透過 {name} 授權",
		"unsupportedType": "暫不支援 {type} 類型的安全方案。",
		"missingType": "安全方案缺少類型，請檢查您的 {type} 文件或身分驗證設定。",
		"failedToauthorize": "授權失敗",
		"failedToRefresh": "更新失敗",
		"configure": "設定 {name}",
		"mutualTlsHint": "雙向 TLS 透過在 TLS 握手期間提供用戶端憑證來進行身分驗證，因此無需在此輸入任何內容。"
	},
	"commandActionForm": { "continue": "繼續" },
	"environment": {
		"thisIsTheActiveEnvironment": "這是目前啟用的環境",
		"active": "已啟用",
		"editEnvironment": "編輯環境",
		"deleteEnvironment": "刪除環境"
	},
	"environmentCreateModal": {
		"environmentName": "環境名稱",
		"thisEnvironmentNameIsAlreadyInUse": "此環境名稱已被使用。",
		"update": "更新環境",
		"add": "新增環境"
	},
	"environmentDeleteModal": {
		"cancel": "取消",
		"deleteEnvironment": "刪除環境",
		"deleteConfirmation": "確定要刪除此環境嗎？此操作無法復原。",
		"title": "刪除 {name}"
	},
	"environmentVariablesDropdown": {
		"variableSuggestions": "變數建議",
		"addVariable": "新增變數"
	},
	"environmentVariablesTable": {
		"name": "名稱",
		"value": "值",
		"actions": "操作",
		"environmentVariableName": "環境變數名稱",
		"environmentVariableValue": "環境變數值"
	},
	"documentSearchModal": {
		"documentSearch": "文件搜尋",
		"documentSearchResults": "文件搜尋結果",
		"navigate": "↑↓ 導覽",
		"select": "⏎ 選擇",
		"keyboardInstructions": "按上箭頭或下箭頭導覽，按 Enter 選擇，輸入文字篩選結果"
	},
	"searchResult": {
		"httpMethod": "HTTP 方法：",
		"path": "路徑：",
		"description": "描述：",
		"heading": "標題",
		"operation": "操作",
		"tag": "標籤"
	},
	"sectionFilter": {
		"all": "全部",
		"auth": "身分驗證",
		"variables": "變數",
		"cookies": "Cookie",
		"headers": "標頭",
		"query": "查詢",
		"body": "主體"
	},
	"requestParams": {
		"addParameter": "新增參數",
		"searchParameters": "搜尋參數",
		"noParametersFound": "沒有符合的參數",
		"clearAll": "清除所有{title}",
		"clear": "清除",
		"clearOptionalParameters": "清除選填參數"
	},
	"responseBodyDownload": {
		"download": "下載回應主體",
		"label": "下載",
		"body": "回應主體"
	},
	"responseMetaInformation": {
		"duration": "回應資訊，耗時：",
		"size": "，大小：",
		"status": "，狀態："
	},
	"authSelector": {
		"selectedType": "已選身分驗證類型：{type}",
		"multipleTypes": "已選擇多個身分驗證類型",
		"selectType": "選擇身分驗證類型",
		"optional": "選用",
		"required": "必填",
		"deleteScheme": "刪除 {name}",
		"requiredGroup": "必要的身分驗證",
		"availableGroup": "可用的身分驗證",
		"addGroup": "新增身分驗證"
	},
	"operationBlock": {
		"webhookUrlRequired": "Webhook URL 為必填項。請先輸入目標位址。",
		"pathParametersRequired": "路徑參數必須有值。",
		"forbiddenMethod": "Fetch API 無法傳送 {method} 請求。"
	},
	"dataTableCheckbox": { "toggle": "切換" },
	"pillTooltipHost": {
		"computedAtExecution": "在執行請求時計算",
		"noValue": "無值"
	},
	"authOptions": {
		oauth2DeviceAuthorization: "OAuth2 裝置授權",
		"apiKeyCookie": "Cookie 中的 API 金鑰",
		"apiKeyHeader": "請求標頭中的 API 金鑰",
		"apiKeyQuery": "查詢參數中的 API 金鑰",
		"httpBasic": "HTTP Basic",
		"httpBearer": "HTTP Bearer",
		"oauth2Implicit": "OAuth2 隱式流程",
		"oauth2Password": "OAuth2 密碼流程",
		"oauth2ClientCredentials": "OAuth2 用戶端認證資訊",
		"oauth2AuthorizationFlow": "OAuth2 授權碼"
	},
	"deleteSidebarListElement": { "delete": "刪除 {name}" },
	"deleteModal": { "delete": "刪除 {name}" }
};
//#endregion
export { zhTw };

//# sourceMappingURL=zh-tw.js.map